import { signal } from '@preact/signals-react';
import { extrairMensagemErro } from '../requests/erros';

export const alertaMensagem = signal({
    open: false,
    title: 'Erro',
    message: 'Erro desconhecido',
    type: 'error',
    options: [],
    onClose: undefined,
});

export const emitirAlerta = ({ title = 'Erro', message, type = 'error', options, onClose } = {}) => {
    alertaMensagem.value = {
        open: true,
        title,
        message,
        type,
        options: options || [],
        onClose,
    };
};

export const fecharAlerta = () => {
    alertaMensagem.value = { ...alertaMensagem.value, open: false };
};

export const emitirSucesso = (message, title = 'Sucesso') => emitirAlerta({ title, message, type: 'success' });

export const emitirConfirmacao = ({
    title = 'Confirmação',
    message,
    onSim,
    onNao,
    sim = 'Sim',
    nao = 'Não',
} = {}) => {
    emitirAlerta({
        title,
        message,
        type: 'confirmation',
        options: [
            {
                title: sim,
                onClick: () => {
                    fecharAlerta();
                    onSim?.();
                },
            },
            {
                title: nao,
                onClick: () => {
                    fecharAlerta();
                    onNao?.();
                },
            },
        ],
    });
};

// Emissão a partir de um erro axios; mensagem/título localizados são opcionais.
export const emitirAlertaErro = (err, { mensagemPadrao, title = 'Erro' } = {}) => {
    console.error(err);
    emitirAlerta({ title, message: extrairMensagemErro(err, mensagemPadrao), type: 'error' });
};
